import { useNavigate } from 'react-router-dom';
import { useAssistantStore } from '../model/assistantStore';

/** Asks a question in a new chat on Ask Research, from any page. */
export function useAskResearch() {
  const ask = useAssistantStore((s) => s.ask);
  const navigate = useNavigate();
  return (question: string) => {
    ask(question);
    void navigate('/');
  };
}
